import "./ProgressBar.css";

const ProgressBar = (progress) => {

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <progress id="file" value={progress.value} max="100" style={{marginTop:'260px',position:"fixed"}}></progress>
      <span style={{position:"fixed",marginTop:"230px"}}>Generando...</span>
    </div>
  );
};
export default ProgressBar;
